import { get } from "lodash";

const styles = (theme) => ({
  pageContentContainer: {
    minHeight: 'calc(100vh)',
    width: '100%',
  },
  pageContent: {
    backgroundColor: get(theme, 'color.uiBackground'),
    padding: '36px 48px',
    border: "1px solid #D9D9D9",
    width: "424px !important",
    margin: "0 auto",
    marginTop: 60,
  },
  page: {
    margin: "auto !important",
    padding: "3rem",
  },
  flexCenter: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  imgLogo: {
    '& img': {
      width: '100px !important',
      height: 'auto !important',
    },
  },
  heading: {
    textAlign: "center",
    marginBottom: "0px !important",
  },
  pageDescription: {
    textAlign: "center",
    marginTop: 10,
  },
  alternateLogo: {
    marginBottom: 0,
  },
  submitButton: {
    width: "100%",
    '&:focus': {
      border: `1px solid #FFFFFF`,
      outline: `1px solid ${get(theme, 'color.primaryButtonBackground')}`,
    },
  },
  alertMessagesContainer: {
    width: "95% !important",
    marginLeft: "1rem !important",
    marginTop: "-3rem !important",
  },
  fieldContainer: {
    marginBottom: "10px !important",
    width: "100% !important",
  },
  formDialog: {
    width: 400,
  },
  formDialogDescription: {
    marginTop: 20,
  },
})

export default styles;